import {AnyAction} from 'redux';
import {FrameActions} from '@mc/react-frame';
import {EditorToolType} from '../enums';
import {Coordinate} from '../types';

/**
 * Dodatečné parametry pro aktivací nástroje editoru.
 *
 * Využití jednotlivých parametrů je specifické,
 * dle konkrétního typu nástroje.
 */
export interface ToolActivationParams {
    /**
     * Souřadnice na kterých aktivovat nástroj.
     */
    position?: Coordinate;
}

/**
 * Akce mapového editoru a jeho nástrojů.
 */
const EditorActions = {
    /**
     * Aktivuje nástroj s danými ID.
     *
     * @param area - Oblast store.
     * @param toolId - ID nástroje.
     * @param toolParams - Dodatečné parametry pro aktivaci nástroje.
     * @returns Akce.
     */
    activateToolWithId(area: string, toolId: string, toolParams?: ToolActivationParams): AnyAction {
        return FrameActions.postMessage(area, {
            type: 'TOOL_ACTIVATION',
            toolId,
            toolParams,
        });
    },

    /**
     * Aktivuje nástroj s danými typem.
     *
     * @param area - Oblast store.
     * @param toolType - Typ nástroje.
     * @param toolParams - Dodatečné parametry pro aktivaci nástroje.
     * @returns Akce.
     */
    activateToolWithType(area: string, toolType: EditorToolType, toolParams?: ToolActivationParams): AnyAction {
        return FrameActions.postMessage(area, {
            type: 'TOOL_ACTIVATION',
            toolType,
            toolParams,
        });
    },
};

export default EditorActions as Readonly<typeof EditorActions>;
